import { Body1, Display2 } from '@sainsburys-tech/luna-typography'
import { IText } from '../../../../../types/ComponentTypes/Components'
import parse from 'html-react-parser'

function TextComponent({ label, value, style }: IText) {
  return (
    <>
      {label && (
        <Display2
          id="s-reporting-text-title"
          className={style === 'center' ? 's-text-align-center' : undefined}
          element="h6"
          label={label || ''}
        >
          {parse(label)}
        </Display2>
      )}
      <Body1
        id="s-reporting-text-body"
        className={style === 'summary-text' ? 's-summary-text' : undefined}
        element="p"
      >
        {parse(value || '')}
      </Body1>
    </>
  )
}

export default TextComponent
